export default __webpack_public_path__ + "static/media/bbps-Broadband.daa8d542.svg";